import { Box } from '@mui/material'
import TruncatedText from './TruncatedText'
import { memo, ReactElement, useCallback, useMemo, useState } from 'react'
import SimplePopup from './SimplePopup'
import { IMRTColumn } from '../Entity/interfaces'
import { EntityJSONParsedValues } from '../ViewEntity/interfaces'
import { useTranslation } from 'react-i18next'

export interface IJSONDataTypeProps {
    item: IMRTColumn
    dataValue: any
    fontSize?: string
}

const EntityJsonTypeData = (props: IJSONDataTypeProps): ReactElement => {
    const { t } = useTranslation()
    const { item, dataValue, fontSize } = props
    const [isJsonOpen, setIsJsonOpen] = useState(false)
    const [viewJsonValue, setViewJsonValue] = useState('')
    const [viewJsonTitle, setViewJsonTitle] = useState('')

    const locationString = useMemo(() => {
        let geoJsonValue: any = ''
        if (dataValue) {
            geoJsonValue = Array.isArray(dataValue) ? dataValue : [dataValue]

            geoJsonValue = geoJsonValue?.map(
                ({
                    uid,
                    entityId,
                    templateId,
                    templateName,
                    ...rest
                }: EntityJSONParsedValues) => rest,
            )
        }

        return geoJsonValue
    }, [dataValue])

    const onOpenJsonView = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let selectedCellValue: any = Array.isArray(locationString)
            ? locationString
            : [locationString]

        try {
            selectedCellValue = JSON.stringify(
                JSON.parse(selectedCellValue),
                null,
                2,
            )
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Json type error:', e)
        }
        setIsJsonOpen(true)
        setViewJsonValue(selectedCellValue)
        setViewJsonTitle(item.accessorKey)
    }, [item, locationString])
    return (
        <>
            <Box
                id={'geo-json-location-json'}
                onClick={onOpenJsonView}
                sx={{
                    color: '#6d6dff',
                    cursor: 'pointer',
                    width: '100%',
                }}
            >
                <TruncatedText
                    sx={fontSize ? { fontSize } : undefined}
                    text={locationString ? t('viewJson') : ''}
                />
            </Box>

            <SimplePopup
                isOpen={isJsonOpen}
                onClickBack={() => {
                    setIsJsonOpen(false)
                    setViewJsonValue('')
                    setViewJsonTitle('')
                }}
                title={viewJsonTitle}
            >
                <Box sx={{ height: '100%' }}>
                    <textarea
                        style={{
                            width: '100%',
                            maxWidth: '100%',
                            minWidth: '100%',
                            height: '100%',
                            borderRadius: '4px',
                            borderColor: 'rgb(0 0 0 / 25%)',
                        }}
                        value={
                            Array.isArray(viewJsonValue)
                                ? JSON.stringify(viewJsonValue, null, 2)
                                : viewJsonValue
                        }
                        disabled
                    />
                </Box>
            </SimplePopup>
        </>
    )
}

const MemoizedEntityJsonTypeData = memo(EntityJsonTypeData)
MemoizedEntityJsonTypeData.displayName = 'EntityJsonTypeData'
export default MemoizedEntityJsonTypeData
